<template>
  <div class="content mb-5">
    <t-sub-nav :items="tabNavItems" class="mb-5" />

    <b-row class="mb-6">
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="name"
          :label="this.$t('Hostname')"
          :state="$validateState($v.form.domain)"
        >
          <b-form-input
            id="hostname"
            data-test-id="dns-lookup-hostname"
            @blur="setValidationInput('domain', $event.target.value)"
            :state="$validateState($v.form.domain)"
            :placeholder="this.$t('Enter Hostname')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.domain.required">
              {{ $t("This is a required field.") }}
            </p>
            <p v-if="$v.form.domain.required && !$v.form.domain.maxLength">
              {{ $t("Must contain at most 200 characters.") }}
            </p>
          </template>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
    </b-row>

    <transition name="fade" mode="out-in">
      <section v-if="Object.keys(contentData).length > 1 && !loading">
        <section class="result-content">
          <h4>{{ contentData.header }}</h4>
          <div class="result-content-items">
            <pre>{{ contentData.items }}</pre>
          </div>
        </section>
      </section>
    </transition>

    <t-save-button
      data-test-id="dns-lookup-save"
      :btn-text="$t('Run')"
      :form-model="$v.form"
      :fetching="fetching"
      @submit="onSubmit"
    />
  </div>
</template>

<route>
{
  "name": "System DNS Lookup"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("tools", ["dnsLookUp", "clearCache"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async onSubmit() {
      this.contentData = {};
      this.fectching = true;
      try {
        await this.dnsLookUp(this.form.domain);
      } finally {
        this.fetching = false;
        this.$v.form.$reset();
        if (this.toolsDns) {
          this.contentData.header = this.$t("DNS Lookup");
          this.contentData.items = this.toolsDns.output;
        }
        this.clearCache();
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser", "authUser"]),
    ...mapGetters("tools", ["toolsDns"]),
  },
  data: function () {
    return {
      loading: true,
      fetching: false,
      form: {
        domain: null,
      },
      contentData: {},
      tabNavItems: this.$secondaryNav.toolsNavItems.system(),
    };
  },
  validations: {
    form: {
      domain: {
        required,
        maxLength: maxLength(200),
      },
    },
  },
  async created() {
    this.setPageTitle(this.$t("Tools"));
    this.loading = false;
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "The diagnostic tools allow you to test filtering, to evaluate domains and to recategorize domains."
      ),
    ]);
  },
};
</script>
